// extracted by mini-css-extract-plugin
export default {"AppHeader":"AppHeader_AppHeader__d-9kU"};